import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

const echo = new Echo({
    broadcaster: "reverb",
    key: "b4uhiuldo9kysulnokas",
    wsHost: "127.0.0.1",
    wsPort: 8080,
    wssPort: 8080,
    forceTLS: false,
    enabledTransports: ["ws"],

    authorizer: (channel, options) => {
        return {
            authorize: (socketId, callback) => {
                fetch("http://127.0.0.1:8000/broadcasting/auth", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        // 👇 har request pe fresh token localStorage se uthega
                        "Authorization": `Bearer ${localStorage.getItem("authToken")}`,
                    },
                    body: JSON.stringify({
                        socket_id: socketId,
                        channel_name: channel.name,
                    }),
                })
                    .then((res) => res.json())
                    .then((data) => callback(false, data))
                    .catch((err) => callback(true, err));
            },
        };
    },
});

echo.connector.pusher.connection.bind("connected", () => {
    console.log("✅ Connected to Reverb");
});

echo.connector.pusher.connection.bind("error", (err) => {
    console.log("❌ Reverb Error:", err);
});

export default echo;